import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as organizationLogoActions } from '../../ducks/organizationLogo';
export class FetchOrganizationLogo extends Component {
    componentDidMount() {
        const { organizationLogo, ORGANIZATION_LOGO_ACTIONS: { REQUEST }, } = this.props;
        if (!organizationLogo)
            REQUEST();
    }
    render() {
        return null;
    }
}
const mapStateToProps = (state) => ({
    organizationLogo: state.organizationLogo.get('logo'),
});
const mapDispatchToProps = (dispatch) => ({
    ORGANIZATION_LOGO_ACTIONS: bindActionCreators(organizationLogoActions, dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(FetchOrganizationLogo);
